<template>

  <div class="d-flex justify-content-center min-vh-100">
    <div class="col-md-8 d-flex flex-column">
      <!-- Logo -->
      <div class="row p-3">
        <img src="../../../assets/QDBlogo.png" style="height: 140px; width: auto" alt="logo" class="img-fluid"/>
      </div>

      <!-- Divider -->
      <div class="w-100 border-top border-bottom border-1 py-3"
           style="background-color: #F5F5F5; border-color: #A0A0A0"></div>

      <!-- Left & Right -->
      <div class="row p-3">
        <!-- Left Panel -->
        <div class="col-md-4 border-end border-5 px-3" style="border-color: #A0A0A0">
          <!-- Register or Login -->
          <div>
            <p class="fs-5 fw-semibold text-primary">
              Register or Login
            </p>

            <!-- 2nd Divider -->
            <div class="mx-0 w-75 hrLine"></div>

            <!-- Buttons -->
            <div class="d-flex justify-content-start gap-2 my-4">
              <a :href="d365Link" target="_blank" class="btn btn-primary">Sign In</a>
              <router-link to="/Registration" type="button" class="btn btn-outline-primary">Register Now</router-link>
            </div>

          </div>

          <!-- E-Tendering Helpdesk -->
          <div class="mt-5">
            <p class="fs-5 fw-semibold text-primary">
              E-Tendering Helpdesk
            </p>

            <!-- 2nd Divider -->
            <div class="mx-0 w-75 hrLine"></div>

            <div>
              <p class="fw-semibold">Need assistance?</p>
              <div class="my-3">
                <p class="mb-1" style="font-size: 14px">Please contact our E-Tendering Helpdesk:</p>
                <p class="mb-0" style="font-size: 14px;"><strong>Phone: </strong><a href="tel:0097444300560"
                                                                                    target="_blank"
                                                                                    style="text-decoration: none;">+974
                  4430 0560</a></p>
                <p class="mb-0" style="font-size: 14px;"><strong>Email: </strong><a href="mailto:eprocurement@qdb.qa"
                                                                                    style="text-decoration: none;">eprocurement@qdb.qa</a>
                </p>
              </div>
            </div>
          </div>

        </div>

        <!-- Right Panel -->
        <div class="col-md-8 ps-4">
          <!-- Welcome to QDB -->
          <div>
            <p class="fs-4 fw-semibold text-primary">
              Welcome to QDB E-Tendering Portal
            </p>

            <p class="text-justify" style="font-size: 14px">
              This portal provides a suite of Collaborative, web-based tools that enable Qatar Development Bank
              procurement professionals and suppliers to conduct sourcing and contract management activihes.
            </p>

            <p class="text-justify" style="font-size: 14px">
              The combination of a secure integrated platform, global knowledge base and aligned organizational
              procurement processes will better analyze, source, contract, and manage each business unit's spend and
              suppliers for greater performance, productivity and efficiency.
            </p>
          </div>

          <!-- Supplier Technical Support and Guidance -->
          <div class="mt-5">
            <p class="fs-5 fw-semibold text-primary">
              Supplier Technical Support and Guidance
            </p>

            <!-- 2nd Divider -->
            <div class="mx-0 w-75 hrLine"></div>

            <!-- Button -->
            <div class="my-4">
              <div class="d-flex flex-wrap gap-3">
                <a v-for="file in pdfFiles" :key="file.name" :href="file.link" target="_blank"
                    class="btn btn-primary d-flex align-items-center gap-2" :download="file.name">
                  <i class="fa-solid fa-file-arrow-down"></i>
                  <span>{{ file.name.replace('.pdf', '') }}</span>
                </a>
              </div>
            </div>

          </div>
        </div>
      </div>

      <!-- Footer -->
      <div class="mt-auto">
        <div class="row p-3 ps-3" style="background-color: #3B3B3B; border-top: 0.55rem solid #6e48aa;">
          <p class="text-white mb-0">&copy; 2025 QDB e-Tendering Portal</p>
        </div>
      </div>

    </div>
  </div>

</template>

<script>
import vendorBidding from '../../../assets/Vendor Bidding.pdf';
import poConfirmation from '../../../assets/PO Confirmation.pdf';
import preQualifyingPage from '../../../assets/New Vendor Pre-Qualifiying page.pdf';
import registrationWizard from '../../../assets/New Vendor Registration Wizard.pdf';
import contractManagement from '../../../assets/Contract Management.pdf';
import invoiceCreation from '../../../assets/Invoice Creation.pdf';

export default {
  name: 'HomePage',
  data() {
    return {
      d365Link: '',
      pdfFiles: [
        {link: vendorBidding, name: 'Vendor Bidding.pdf'},
        {link: poConfirmation, name: 'PO Confirmation.pdf'},
        {link: preQualifyingPage, name: 'New Vendor Pre-Qualifying page.pdf'},
        {link: registrationWizard, name: 'New Vendor Registration Wizard.pdf'},
        {link: contractManagement, name: 'Contract Management.pdf'},
        {link: invoiceCreation, name: 'Invoice Creation.pdf'},
      ]
    };
  },
  methods: {
    getLink: async function () {
      try {
        const result = await GetD365Link();
        //console.log('Link:' ,result.link);

        this.d365Link = result.link;
      } catch (error) {
        console.error("Error fetching D365 Link:", error);
      }
    },
  },
  watch: {},
  async mounted() {
    await this.getLink();
  }
};
</script>

<style scoped>
.hrLine {
  background-color: #6e48aa !important;
  border: 2px solid #6e48aa;
  line-height: 1px;
  height: 0px;
  margin: 10px 0 16px;
  padding: 0;
}

.text-justify {
  text-align: justify
}
</style>
